enum ButtonType {
    DEFAULT = 'default',
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
}

export default ButtonType;